import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { RoutineAction } from '../../../models';
import Change from '../../../models/Change';
import { Select } from '../../Select';
import type { Value } from '../../Select';

interface SetStatusFormProps {
    action: RoutineAction;
    onSave?: (action: RoutineAction) => void;
}

function SetStatusForm(props: SetStatusFormProps) {
    const { action, onSave } = props;
    const { t } = useTranslation();
    const [options, setOptions] = useState<AnyObj>(action.options || {});

    useEffect(() => {
        onSave && onSave({ ...action, options });
    }, [options]);

    const statuses = [
        Change.STATUS_PENDING_TRIAGE,
        Change.STATUS_SPAM_SUSPECT,
        Change.STATUS_DISCARDED,
        Change.STATUS_PENDING_ESTIMATE,
        Change.STATUS_ASSIGNED,
        Change.STATUS_IN_PROGRESS,
        Change.STATUS_FINISHED,
    ];

    return (
        <div className="grid grid-cols-1 xl:grid-cols-4 gap-2 bg-purple-50 dark:bg-purple-950/30 p-2 border rounded w-full">
            <label className="text-sm col-span-1">{t('projects.routine.action.status')}</label>
            <div className="col-span-3">
                <Select
                    defaultValue={options.status as Value}
                    options={statuses.map((s) => ({
                        value: s,
                        label: t(`changes.progress_status_type.${s}`) || s
                    }))}
                    onChange={(status: any) => setOptions({ ...options, status })}
                    className="border rounded border-gray-300 dark:border-gray-600 w-full"
                    placeholder={t('projects.routine.action.choose_status') || ''}
                />
            </div>
        </div>
    );
}

export default SetStatusForm;
